const body = document.body;
const searchOverlay = document.querySelector('#srchdiv');
const searchInput = document.querySelector('#srchdiv_input');
const searchClose = document.querySelector('#search_hide');

export function setSearch(open) {
  if (!searchOverlay) return;
  searchOverlay.hidden = !open;
  searchOverlay.setAttribute('aria-hidden', String(!open));
  body.classList.toggle('np-search-open', open);
  if (open) window.requestAnimationFrame(() => searchInput?.focus());
}

document.querySelectorAll('.srchButton').forEach((button) => {
  button.addEventListener('click', () => setSearch(true));
});
searchClose?.addEventListener('click', () => setSearch(false));
searchOverlay?.addEventListener('click', (event) => {
  if (event.target === searchOverlay) setSearch(false);
});
